<div class="row">
  <div class="col-lg-auto col-md-12 col-sm-12 d-flex justify-content-center">
    <div class="workspace-img-div">
      @if (_workspace?.avatarUrl) {
        <img
          class="workspace-img-div"
          [ngSrc]="_workspace?.avatarUrl"
          alt="workspace-avatar"
          fill=""
          (error)="onImageError()" />
      } @else {
        <span
          class="c-full-white profile-text text-uppercase h-100 w-100 d-flex"
          [style.background-color]="timelineService.getColorFromName(_workspace?.name)">
          {{ _workspace?.name | slice: 0 : 2 }}
        </span>
      }
      <button type="button" class="badge btn badge-edit-button" (click)="$event.stopPropagation(); editAvatar()">
        <i class="fa fa-cog fa-lg"></i>
      </button>
    </div>
  </div>

  <div class="col-lg-11 col-md-12 col-sm-12 d-flex flex-wrap" [style.gap]="'5px'">
    <div class="w-100">
      <span class="f-12 _700">{{ 'workspace_workspaceName' | translate }}</span>
    </div>
    <div class="w-100">
      <form [formGroup]="headerForm" class="workspace-form" [ngClass]="{ 'has-danger': isValid('name') }">
        <input
          type="text"
          class="form-control input-section f-12 _400 w-100 ps-2"
          maxlength="64"
          placeholder="{{ 'workspace_workspaceName' | translate }}"
          (input)="removeLeadingSpaces('name')"
          formControlName="name" />

        @if (headerForm.get('name').hasError('htmlNotAllowed') && headerForm.get('name').touched) {
          <span>{{ headerForm.get('name').getError('htmlNotAllowed') | translate }}</span>
        }

        @if (nameValue?.length === 64) {
          <div>
            <small class="text-danger">You have reached the 64 character limit.</small>
          </div>
        }
      </form>
    </div>
  </div>
</div>

<div class="card mt-4 mb-4">
  <div class="d-flex flex-wrap w-100 mt-3 p-3">
    <button
      type="button"
      class="add-user-btn align-items-center btn d-flex justify-content-center text-nowrap text-uppercase"
      (click)="showUserModal()">
      <div class="circle d-flex justify-content-center align-items-center">
        <i class="fa fa-plus" aria-hidden="true"></i>
      </div>
      <span class="ms-2">{{ 'workspace_edit_addNewUser' | translate }}</span>
    </button>
  </div>

  <div class="d-flex flex-wrap w-100">
    <div class="col-12 d-flex flex-lg-nowrap flex-md-wrap flex-sm-wrap w-100 my-3">
      <div
        class="d-flex justify-content-lg-end justify-content-md-center justify-content-sm-center justify-content-center w-100">
        <button type="button" (click)="showPermissionDetailsInfo()" class="me-3 permission-detail-btn btn f-10 _400"
          >PERMISSION DETAILS</button
        >
      </div>
    </div>
  </div>

  <div class="mt-4">
    <div class="d-lg-flex d-md-flex d-none w-100">
      <div class="col-md-3 table-header-text">User</div>
      <div class="col-md-7 table-header-text">Email</div>
      <div class="col-md-2 table-header-text">Actions</div>
    </div>

    @for (user of filteredUsers; track $index) {
      <div class="d-flex flex-wrap w-100 py-3 user-detail">
        <div class="align-items-center col-12 col-md-3 d-flex justify-content-start flex-wrap p-0" [style.gap]="'20px'">
          <span class="d-md-none fw-bold table-header-text ms-1">Name </span>

          @if (!user.user?.avatarUrl) {
            <mtm-user-profile-picture
              [user]="user"
              [username]="user.username"
              width="35"
              height="35"></mtm-user-profile-picture>
          } @else {
            <img [ngSrc]="user?.user?.avatarUrl" class="rounded-circle" alt="user-avatar" width="35" height="35" />
          }

          <span class="f-12 _400">{{ user.fullName }}</span>
        </div>

        <div class="align-items-center col-12 col-md-7 d-flex justify-content-start flex-wrap p-0" [style.gap]="'20px'">
          <span class="d-md-none fw-bold table-header-text ms-1">Email</span>
          <span class="f-12 _400 _1-line-text-ellipsis">{{ user.user.email }}</span>
        </div>

        @if (checkOwner(user.user.email)) {
          <div
            class="align-items-center col-12 col-md-2 d-flex justify-content-start flex-wrap p-0"
            [style.gap]="'10px'">
            <span class="d-md-none fw-bold table-header-text ms-1">Action</span>

            @if (workspace?.createdBy !== user.user.email) {
              <button type="button" (click)="removeUser(user.user)" class="btn btn-link p-0">
                <i class="fa fa-trash" [style.color]="'#E45933'"></i>
                <span class="c-mtm-full-black f-12 _400 ms-1">Remove</span>
              </button>
            }
          </div>
        }
      </div>
    }
  </div>

  <mtm-upload-file
    [preDefinedFilter]="['IMAGE_FILTER']"
    [hidden]="true"
    #avatarUploader
    (files)="fileChangeListener($event)"
    [style.display]="'none'">
  </mtm-upload-file>

  <mtm-upload-file
    [preDefinedFilter]="['IMAGE_FILTER']"
    [hidden]="true"
    #coverUploader
    (files)="fileChangeListener($event, 'cover')"
    [style.display]="'none'">
  </mtm-upload-file>
</div>
